import { callTel, formatDate, handleAttachmentSrc, lazyVideoSrc, handleImgSrc } from '../utils/articleTool'
import { isArd, isiOS, isMideaConnect, isPC } from '../utils/utils'
import poster from '../assets/images/black.png'
import platfrom from '../platform'
export const articleMixin = {
  data () {
    return {
      errorStatus: false,
      articleId: '',
      base_appkey: '',
      sid: '',
      username: '',
      ssoToken: '',
      swiperImg: [],
      showIndex: 0,
      forbidShow: false,
      videoNumber: 0,
      myPlayer: undefined,
      currentClickedVideo: '',
      videoArr: [],
      scrollTop: 0
    }
  },
  computed: {
    commentNumber () {
      return this.$store.getters.commentNumber
    }
  },
  filters: {
    showWeekday (input) {
      // console.log('input', this.formatDate(input, 'yyyy-MM-dd HH:mm:ss'))
      if (input && input !== '') {
        input = formatDate(input, 'yyyy-MM-dd HH:mm:ss')
      }
      if (input && input !== '') {
        const input2 = input.replace(/-/g, '/')
        const date = new Date(input2)
        const dateYear = date.getFullYear()
        const now = new Date()
        if (dateYear === now.getFullYear()) {
          return input.substr(5, input.length - 3 - 5)
        } else {
          return input.substr(2, input.length - 3 - 2)
        }
      }
    }
  },
  methods: {
    handleArticleData (data) {
      if (data && data.data) {
        if (data.data.code === 0) {
          // 先判断是不是资讯中心同步过来的，并且是不是预览。这部分是文章预览的if条件
          console.log(this.$route)
          if (this.$route.path === '/articlePreview' &&
            !data.data.data.content &&
            data.data.data.jumpUrl.indexOf('/newservicenopages/#/content') > -1
          ) {
            const query = data.data.data.jumpUrl.split('?')[1]
            const queryArr = query.split('&')
            const query1 = { id: '', type: '' }
            for (let i = 0; i < queryArr.length; i++) {
              const key = queryArr[i].split('=')[0]
              const value = queryArr[i].split('=')[1]
              if (key === 'id') {
                query1.id = value
              }
              if (key === 'type') {
                query1.type = value
              }
            }
            this.$router.replace({
              path: '/content/preview',
              query: {
                id: query1.id,
                type: query1.type
              }
            })
          }
          const result = data.data.data
          const range = result.shareRange ? result.shareRange : 0
          // 2022.09.19 新需求 -- 限制分享的文章，如果用外部浏览器打开，跳转到error页面。
          // 对分享类型做处理
          this.handleShareRange(range)
          // 2022.12.15 新需求 -- 把描述放进meta标签里，用于客户端转发分享
          const description = result.summary
          this.handleDescription(description)
          // 功能：设置浏览器标签页的图标
          const link = document.getElementsByTagName('link')
          for (let i = 0; i < link.length; i++) {
            if (link[i].rel === 'icon') {
              link[i].href = result.coverImg
              break
            }
          }
          // 功能：移动端防止标题过长而截取标题
          // 服务号内容推送，加上文章标题
          if (!(this.$route.path === '/content/detail' || this.$route.path === '/content/preview')) {
            document.title = result.title.length > 20 ? result.title.substr(0, 20) + '...' : result.title
          }
          // 服务号采用资讯中心外链推送，加上文章标题
          if ((this.$route.path === '/content/detail' || this.$route.path === '/content/preview') && this.$route.query.type === '2') {
            document.title = result.title.length > 20 ? result.title.substr(0, 20) + '...' : result.title
          }
          // 预览页把视频链接加上文章中展示
          if(this.$route.path === '/content/preview' && data.data.data.videoUrl) {
            const addContent = `<p style="display: flex;justify-content: center;">
                <video class="video-js vjs-big-play-centered" controls="" data-setup="{}" width="360" height="202" poster="${data.data.data.videoUrlCover}">
                    <source src="${data.data.data.videoUrl}"/>
                </video>
            </p>`
            result.content = addContent
          }
          this.$store.dispatch('setArticleTitle', {
            articleTitle: result.title.length > 20 ? result.title.substr(0, 20) + '...' : result.title
          })
          if (data.data.data.state === -1) {
            this.$router.push({
              name: 'articleDelete',
              query: { type: 'deleted' }
            })
          }

          this.$store.dispatch('setArticle', { article: result })
          this.parseArticleData(result)
          // this.parseArticleDataV2(result);
        } else if (data.data.code === 30003) {
          // 注释：30003代表外链类型的文章，将访问资讯中心外的地址
          const shareRange = data.data.data.shareRange ? data.data.data.shareRange : 0
          this.handleShareRange(shareRange)
          const description = data.data.data.summary ? data.data.data.summary : ''
          this.handleDescription(description)
          if ((this.$route.path === '/content/detail' ||
               this.$route.path === '/content/preview') &&
               isMideaConnect() &&
               !isPC()) {
            // 调取cordova方法显示nav
            document.addEventListener('deviceready', function () {
              platfrom.showNav().then(() => {
                console.log('showNav')
                let jumpUrl = data.data.data.jumpurl
                if (
                  jumpUrl.indexOf('http://') < 0 &&
                  jumpUrl.indexOf('https://') < 0
                ) {
                  jumpUrl = 'http://' + jumpUrl
                }
                console.log(jumpUrl)
                window.location.replace(jumpUrl)
              })
            }, false)
          } else {
            let jumpUrl = data.data.data.jumpurl
            if (
              jumpUrl.indexOf('http://') < 0 &&
              jumpUrl.indexOf('https://') < 0
            ) {
              jumpUrl = 'http://' + jumpUrl
            }
            console.log(jumpUrl)
            window.location.replace(jumpUrl)
          }
        } else {
          this.success = false
          this.$toastMessage({
            icon: '&#xe69f;',
            message1: data.data.msg
          })
          this.errorStatus = true
        }
      }
    },
    parseArticleData (result) {
      this.videoNumber = 0
      let tempArr = []
      result.content = callTel(result.content)
      result.content = handleImgSrc(result.content)
      tempArr = lazyVideoSrc(result.content)
      result.content = tempArr[0]
      this.videoNumber = tempArr[1]
      if (isArd() || isiOS()) {
        result.content = handleAttachmentSrc(result.content)
      }
      this.articleDetail = result
      this.articleDetail.description = result.summary || ''
      const self = this
      /* eslint-disable */
      this.$store.dispatch('setContentWidth', { contentWidth: $('#content').width() })
      this.$nextTick(() => {
        self.$store.dispatch('setShowLoadingPic', { showLoadingPic: false })
        $('#content img:lt(3)').not('[data-icon="1"]').each(function () {
          if ($(this).attr('data-w') && Number($(this).attr('data-w')) != '0') {
            if (
              Number($(this).attr('data-w')) > Number($('#content').width()) &&
              $(this).attr('data-ratio') * 100 > 100 &&
              $(this).hasClass('ue-editor-image')
            ) {

              const clientWidth = $('#content').width()
              const originWidth =  Number($(this).attr('data-w'));
              const originHeight = Number($(this).attr('data-h'));

              if (clientWidth > originWidth) {
                $(this).attr('height', originHeight + 'px')
                $(this).attr('width', originWidth + 'px')
              } else {

                $(this).attr('width', clientWidth + 'px')

                /**
                 *  originWidth     newWidth
                 *     ___       =  _________
                 *
                 * originHeight     newHeight
                 */
                let newHeight = (clientWidth * originHeight) / originWidth;
                $(this).attr('height', newHeight + 'px')
              }
            }
          }
        })
        if (!(this.$route.path.indexOf('content') > -1)) {
          $('#content img:gt(2)').not('[data-icon="1"]').lazy({
            threshold: 500,
            beforeLoad: function (element) {
              const clientWidth = self.$store.getters.contentWidth
              const originWidth =  Number($(element).attr('data-w'));
              const originHeight = Number($(element).attr('data-h'));
              // 这是缩略图用的是宽1280*长960,自己服务器的照片采用缩略图
              if ($(element).attr('data-ratio') && $(element).attr('data-w') && $(element).attr('data-w') !== '0') {

                if (clientWidth > originWidth) {
                  // $(element).attr('height', (Number($(element).attr('data-w')) * Number($(element).attr('data-ratio'))) + 'px')
                  $(element).attr('height', originHeight  + 'px')

                  $(element).attr('width', originWidth + 'px')
                } else {

                  // $(element).attr('height', (Number(clientWidth) * Number($(element).attr('data-ratio'))) + 'px')
                  // $(element).attr('width', Number(clientWidth) + 'px')
                  $(element).attr('width', clientWidth + 'px')
                  let newHeight = (clientWidth * originHeight) / originWidth;
                  $(element).attr('height', newHeight + 'px');

                }
              } else {
                $(element).attr('height', $(element).width() + 'px')
                $(element).attr('width', $(element).width() + 'px')
                $(element).attr('data-set', 'true')
              }
              $(element).addClass('img_loading')
            },
            afterLoad: function (element) {
              $(element).removeClass('img_loading')
              if ((!$(element).hasClass('ue-editor-image')) || ($(element).attr('data-set') === 'true')) {
                $(element).removeAttr('height')
                $(element).removeAttr('width')
              }
              if (!$(element).attr('preview')) {
                $(element).attr('preview', '1')
                self.$previewRefresh()
              }
            },
            onError: function (element) {
              // called whenever an element could not be handled
              $(element).removeClass('img_loading')
              $(element).removeAttr('preview')
              $(element).addClass('img_loadederror')
              $(element).click(function () {
                $(this).removeClass('img_loadederror')
                $(this).attr('src', $(this).attr('data-src'))
                if (!this.complete) {
                  $(this).attr('src', 'dist/error.png')
                }
              })
            }
          })
        }
        $('#content video').each(function () {
          const id = $(this).attr('id')
          const posterUrl = $(this).attr('poster')
          let myVideoPlayer = null
          myVideoPlayer = self.$video(document.getElementById(id), {
            autoplay: false,
            preload: 'metadata',
            controls: true,
            poster: posterUrl ? posterUrl : '../assets/images/black.png',
            controlBar: {
              children: [
                { name: 'playToggle' }, // 播放按钮
                { name: 'progressControl' }, // 播放进度条
                { name: 'remainingTimeDisplay' }, // 当前已播放时间
                {
                  name: 'volumePanel', // 音量控制
                  inline: false // 不使用水平方式
                },
                { name: 'FullscreenToggle' } // 全屏
              ]
            }
          })
          myVideoPlayer.poster(posterUrl ? posterUrl : poster)
          myVideoPlayer.on('play', function () {
            myVideoPlayer.play()
            for (let i = 0; i < self.videoArr.length; i++) {
              if (self.videoArr[i].id_ !== myVideoPlayer.id_ && self.videoArr[i].hasStarted_) {
                self.videoArr[i].pause()
              }
            }
          })
          myVideoPlayer.on('fullscreenchange', function (e) {
            if (document.fullscreenElement) {
              console.log('enter fullscreen')
            } else {
              setTimeout(() => {
                if (document.documentElement && document.documentElement.scrollTop) {
                  document.documentElement.scrollTop = self.scrollTop
                } else {
                  document.body.scrollTop = self.scrollTop
                }
                console.log('scrollTo x=0,y=', self.scrollTop)
                window.scrollTo(0, self.scrollTop)
              }, 100)
            }
          })
          self.videoArr.push(myVideoPlayer)
        })
        self.$previewRefresh()
      })
      setTimeout(() => {
        window.onpopstate = function() {
          if (self.$route.path === '/content/detail' && isMideaConnect() && !isPC()) {
            // 调取cordova方法显示nav
            document.addEventListener('deviceready', function () {
              platfrom.hideNav().then(() => {
                console.log('hideNav')
              })
            }, false)
          }
        };
        $('#content a').click(function (event) {
          if (typeof $(this).attr('data-href') !== 'undefined') {
            // _self.showtoastFromDocumentCenter();
            self.$toastMessage({
              icon: '&#xe7a3;',
              message1: '仅支持PC端下载查看'
            })
          } else {
            // event.preventDefault()
            if (self.$route.path === '/content/detail' && isMideaConnect() && !isPC()) {
              // 调取cordova方法显示nav
              document.addEventListener('deviceready', function () {
                platfrom.showNav().then(() => {
                  console.log('showNav')
                  let jumpUrl = $(this).attr('href')
                  if (
                    jumpUrl.indexOf('http://') < 0 &&
                    jumpUrl.indexOf('https://') < 0
                  ) {
                    jumpUrl = 'http://' + jumpUrl
                  }
                  window.location.replace(jumpUrl)
                })
              }, false)
            } else {
              let jumpUrl = $(this).attr('href')
              if (
                jumpUrl.indexOf('http://') < 0 &&
                jumpUrl.indexOf('https://') < 0
              ) {
                jumpUrl = 'http://' + jumpUrl
              }
              window.location.replace(jumpUrl)
            }
          }
        })
      }, 500)
      /* eslint-disable */
    },
    handleShareRange (shareRange) {
      console.log('line 367, shareRange', shareRange)
      // 功能1：设置meta标签的shareRange属性
      // 功能2：不允许分享的文章跳转到error页面
      // shaeRange = 0 -- 不分享 1 -- 只分享美信 2 -- 全部
      const meta = document.getElementsByTagName('meta')
      for (let i = 0; i < meta.length; i++) {
        if (meta[i].id === 'shareRange') {
          meta[i].content = shareRange
          break
        }
      }
      if ((shareRange === 0 || shareRange === 1) && this.$route.path === '/content/detail' && !isMideaConnect()) {
        console.log((shareRange === 0 || shareRange === 1))
        console.log(this.$route.path === '/content/detail')
        console.log(!isMideaConnect())
        console.log((shareRange === 0 || shareRange === 1) && this.$route.path === '/content/detail' && !isMideaConnect())
        if (!(this.$route.query.idtification && this.$route.query.idtification === 'admin')) {
          this.$router.replace({
            path: '/error',
            query: {
              redirectedUrl: encodeURIComponent(window.location.href)
            }
          })
          return
        }
      }
    },
    handleDescription (description) {
      const meta = document.getElementsByTagName('meta')
      for (let i = 0; i < meta.length; i++) {
        if (meta[i].id === 'description') {
          meta[i].content = description
          break
        }
      }
    }
  },
  mounted () {
    const self = this
    window.addEventListener('scroll', function () {
      // console.log('容器高度为:' + (document.documentElement.scrollHeight || document.body.scrollHeight))
      // console.log('滚动高度为:' + (document.documentElement.scrollTop || document.body.scrollTop))
      // console.log('现在将记录滚动高度:' + (document.documentElement.scrollTop || document.body.scrollTop))
      if ((document.documentElement.scrollTop || document.body.scrollTop) !== 0) {
        self.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      }
    })
  }
}
